<template>
    <div>
        <Banner />
        <About :aboutData="config.manageHome.about" />
        <Student />
        <Course />
        <News />
        <Event :eventData="config.manageHome.event" />
    </div>
</template>

<script>
import Banner from '@/components/banner'
import About from './partials/about'
import Event from './partials/event'
import Course from './partials/course'
import Student from './partials/student'
import News from './partials/news'
export default {
    components: {
        Banner, About, Event, Course, Student, News
    },
    props: {
        config: Object
    },
}
</script>